module.exports = __webpack_public_path__ + "static/media/CooperLtBTLight.f390ce82.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/cooper/CooperLtBTLight.woff2
// module id = 171
// module chunks = 56